import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { LayoutDashboard, ShieldCheck, LogOut } from "lucide-react";

export default function Topbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const onLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header className="border-b border-zinc-200 bg-white sticky top-0 z-30">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 h-14">
        <Link to="/" className="flex items-center gap-2.5 font-heading font-black text-lg tracking-tight" data-testid="brand-link">
          <img src="/favicon.svg" alt="" aria-hidden="true" className="w-7 h-7" />
          LeadBridge
        </Link>
        <nav className="flex items-center gap-2">
          {user ? (
            <>
              {user.role === "admin" ? (
                <Link to="/admin">
                  <Button variant={loc.pathname.startsWith("/admin") ? "default" : "ghost"} className="btn-sharp" data-testid="topbar-admin-link">
                    <ShieldCheck className="w-4 h-4 mr-1" /> Admin
                  </Button>
                </Link>
              ) : (
                <Link to="/dashboard">
                  <Button variant={loc.pathname.startsWith("/dashboard") ? "default" : "ghost"} className="btn-sharp" data-testid="topbar-dashboard-link">
                    <LayoutDashboard className="w-4 h-4 mr-1" /> Dashboard
                  </Button>
                </Link>
              )}
              <span className="hidden sm:inline text-xs font-mono text-zinc-500 px-2">{user.email}</span>
              <Button variant="outline" className="btn-sharp" onClick={onLogout} data-testid="topbar-logout-button">
                <LogOut className="w-4 h-4 mr-1" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Link to="/login">
                <Button variant="ghost" className="btn-sharp" data-testid="topbar-login-link">Login</Button>
              </Link>
              <Link to="/register">
                <Button className="btn-sharp bg-[#0055FF] hover:bg-[#0044CC] text-white" data-testid="topbar-register-link">Start Receiving Leads</Button>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
